<template>
  <div>
    <div class="header">
      <h3>
        La pose, le maintien ou le retrait de la signalisation spécifique au
        chantier sont effectués par :
      </h3>
    </div>
    <div class="block-content">
      <fieldset>
        <legend>Identité</legend>
        <div class="form-group">
          <b-row>
            <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
              <label class="control-label">Vous êtes :</label>
            </b-col>
            <b-col lg="10" md="9" sm="12" cols="12" class="form-with-label">
              <b-form-radio-group
                @input="fillData($event)"
                v-model="cerfa.gestSignageCorporation"
                :options="corpos"
              ></b-form-radio-group>
            </b-col>
          </b-row>
        </div>
        <div id="executeur-par">
          <div class="form-group">
            <b-row>
              <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                <label class="control-label">Nom, prénom :</label>
              </b-col>
              <b-col lg="10" md="9" sm="12" cols="12" class="no-padding">
                <b-row class="no-margin">
                  <b-col lg="6" md="6" sm="12" cols="12">
                    <b-form-input
                      v-model="cerfa.gestSignageFirstName"
                      placeholder="Merci de renseigner votre nom"
                      maxlength="100"
                    />
                  </b-col>
                  <b-col lg="6" md="6" sm="12" cols="12">
                    <b-form-input
                      v-model="cerfa.gestSignageLastName"
                      placeholder="Merci de renseigner votre prénom"
                    />
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
        </div>
        <div id="executeur-pro" v-if="cerfa.gestSignageCorporation">
          <div class="form-group">
            <b-row>
              <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                <label class="control-label">Dénomination :</label>
              </b-col>
              <b-col lg="4" md="9" sm="12" cols="12">
                <b-form-input
                  v-model="cerfa.gestSignageCorporationName"
                  placeholder="Merci de renseigner votre dénomination"
                  maxlength="100"
                />
              </b-col>
              <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                <label class="control-label">N° SIRET :</label>
              </b-col>
              <b-col lg="4" md="9" sm="12" cols="12">
                <b-form-input
                  v-model="cerfa.gestSignageCorporationSiret"
                  placeholder="Merci de renseigner votre n° SIRET"
                />
              </b-col>
              <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                <label class="control-label">Représenté par :</label>
              </b-col>
              <!--<b-col lg="2" md="2" sm="12" cols="12">
                                <label class="control-label">Titre, nom, prénom :</label>
                            </b-col>-->
              <b-col lg="10" md="9" sm="12" cols="12" class="no-padding">
                <b-row class="no-margin">
                  <b-col lg="2" md="3" sm="3" cols="12">
                    <b-form-select
                      v-model="cerfa.gestSignageCorporationAgentTitle"
                      :options="titles"
                    ></b-form-select>
                  </b-col>
                  <b-col lg="10" md="9" sm="9" cols="12">
                    <b-form-input
                      v-model="cerfa.gestSignageCorporationAgent"
                      placeholder="Nom du représentant"
                      maxlength="100"
                    />
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
        </div>
      </fieldset>
      <fieldset>
        <legend>Coordonnées</legend>
        <div class="form-group">
          <b-row>
            <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
              <label class="control-label">Numéro :</label>
            </b-col>
            <b-col lg="2" md="9" sm="12" cols="12">
              <b-form-input
                type="number"
                v-model="cerfa.gestSignageAddressNum"
                placeholder="Numéro"
              />
            </b-col>
            <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
              <label class="control-label">Extension :</label>
            </b-col>
            <b-col lg="2" md="9" sm="12" cols="12">
              <b-form-input
                v-model="cerfa.gestSignageAddressExt"
                placeholder="Extension"
                maxlength="10"
              />
            </b-col>
            <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
              <label class="control-label">Type de voie :</label>
            </b-col>
            <b-col lg="2" md="9" sm="12" cols="12">
              <b-form-input
                v-model="cerfa.gestSignageAddressType"
                placeholder="Type de voie"
                maxlength="100"
              />
            </b-col>
            <!--<b-col lg="12" md="12" sm="12" cols="12"></b-col>-->
            <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
              <label class="control-label">Nom de voie :</label>
            </b-col>
            <b-col lg="4" md="3" sm="12" cols="12">
              <b-form-input
                v-model="cerfa.gestSignageAddressName"
                placeholder="Nom de la voie"
              />
            </b-col>
            <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
              <label class="control-label">Lieu-dit ou BP :</label>
            </b-col>
            <b-col lg="4" md="3" sm="12" cols="12">
              <b-form-input
                v-model="cerfa.gestSignageAddressPlace"
                placeholder="Lieu-dit ou boite postale"
              />
            </b-col>
            <!--<b-col lg="12" md="12" sm="12" cols="12"></b-col>-->
            <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
              <label class="control-label">Localité :</label>
            </b-col>
            <b-col lg="6" md="9" sm="12" cols="12">
              <b-form-input
                v-model="cerfa.gestSignageAddressCity"
                placeholder="Localité"
              />
            </b-col>
            <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
              <label class="control-label">Code postal :</label>
            </b-col>
            <b-col lg="2" md="9" sm="12" cols="12">
              <b-form-input
                v-model="cerfa.gestSignageAddressPostalCode"
                placeholder="Code postal"
              />
            </b-col>
          </b-row>
        </div>
        <div class="form-group">
          <b-row>
            <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
              <label class="control-label">Téléphone :</label>
            </b-col>
            <b-col lg="3" md="9" sm="12" cols="12">
              <b-form-input
                v-model="cerfa.gestSignagePhone"
                type="number"
                placeholder="Numéro de téléphone"
              />
            </b-col>
            <b-col lg="4" md="3" sm="12" cols="12" class="no-padding">
              <label class="control-label"
                >Indicatif pour le pays étranger :</label
              >
            </b-col>
            <b-col lg="3" md="9" sm="12" cols="12">
              <b-form-input
                v-model="cerfa.gestSignagePhoneIndicative"
                placeholder="Indicatif pays étranger"
                maxlength="4"
              />
            </b-col>
            <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
              <label class="control-label clearfix">Adresse email :</label>
            </b-col>
            <b-col lg="10" md="9" sm="12" cols="12">
              <b-form-input
                v-model="cerfa.gestSignageEmail"
                placeholder="Adresse email"
              />
            </b-col>
          </b-row>
        </div>
      </fieldset>
    </div>
  </div>
</template>

<script>
import Vuex from "vuex";

export default {
  name: "Signalisation",
  methods: {
    ...Vuex.mapActions("Cerfa", ["setCerfa14024"]),
    fillData(value) {
      if (value == false) {

        this.cerfa.gestSignageLastName = this.petitioner.lastName;
        this.cerfa.gestSignageFirstName = this.petitioner.firstName;
        this.cerfa.gestSignageTitle = "Le demandeur";
        this.cerfa.gestSignageAddressNum = this.petitioner.addressNum;
        this.cerfa.gestSignageAddressExt = this.petitioner.addressExt;
        this.cerfa.gestSignageAddressType = this.petitioner.addressType;
        this.cerfa.gestSignageAddressName = this.petitioner.addressName;
        this.cerfa.gestSignageAddressPostalCode = this.petitioner.addressPostalCode;
        this.cerfa.gestSignageAddressCity = this.petitioner.addressCity;
        this.cerfa.gestSignagePhone = this.petitioner.phone;
        this.cerfa.gestSignagePhoneIndicative = this.petitioner.phoneIndicative;
        this.cerfa.gestSignageEmail = this.petitioner.email;
        this.cerfa.gestSignageCorporationAgentTitle = this.petitioner.corporationAgentTitle;
        this.cerfa.gestSignageCorporationAgent = this.petitioner.corporationAgent;
      } else {
        this.cerfa.gestSignageLastName = "";
        this.cerfa.gestSignageFirstName = "";
        this.cerfa.gestSignageTitle = "Une entreprise spécialisée";
        this.cerfa.gestSignageAddressTitle = "";
        this.cerfa.gestSignageAddressNum = "";
        this.cerfa.gestSignageAddressExt = "";
        this.cerfa.gestSignageAddressType = "";
        this.cerfa.gestSignageAddressName = "";
        this.cerfa.gestSignageAddressPostalCode = "";
        this.cerfa.gestSignageAddressCity = "";
        this.cerfa.gestSignagePhone = "";
        this.cerfa.gestSignagePhoneIndicative = "";
        this.cerfa.gestSignageEmail = "";
        this.cerfa.gestSignageCorporationAgentTitle = "";
        this.cerfa.gestSignageCorporationAgent = "";
      }
    },
  },
  computed: {
    ...Vuex.mapGetters("Cerfa", ["cerfa14024"]),
    ...Vuex.mapGetters("Authentification", ["userConnected"]),
    ...Vuex.mapGetters("Petitioner", ["petitioner"]),
    cerfa: {
      get: function() {
        return this.cerfa14024;
      },
      set: function(newValue) {
        this.setCerfa14024(newValue);
      },
    },
  },
  props: ["value", "demandeurInfo"],
  data() {
    return {
      corpo: "",
      title: "",
      titles: [
        { value: "Monsieur", text: "M." },
        { value: "Madame", text: "Mme" },
        { value: "Monsieur Madame", text: "M. Mme" },
      ],
      corpos: [
        { text: "Le Demandeur", value: false },
        { text: "Une entreprise spécialisée", value: true },
      ],
    };
  },
};
</script>

<style scoped></style>
